module.exports = __webpack_public_path__ + "img/img2.06dde1b6.svg";